import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from 'react-datepicker';
import { useForm } from "react-hook-form";

export default function PropertyLossNoticeForm({ onReview, goBack, defaultValues }) {
  const store_id = sessionStorage.getItem("store_id");
  const manager = sessionStorage.getItem("first_name")
  const { register, handleSubmit, watch, formState: { errors }, control } = useForm({
    defaultValues: {
      store_id,
      reported_by: manager,
      ...defaultValues,
      incident_date: defaultValues?.incident_date ? new Date(defaultValues.incident_date) : null,
      incident_time: defaultValues?.incident_time ? new Date(defaultValues.incident_time) : null,
      reported_date: defaultValues?.reported_date ? new Date(defaultValues.reported_date) : new Date(),
    }
  });


  const onSubmit = data => console.log(data);

  // Watch any fields if you want conditional rendering, e.g.:
  // const someField = watch("someFieldName");


  const driver_info = watch("driver_info")
  const insurance_info = watch("insurance_info")
  const vechile_info = watch("vechile_info")
  const witness = watch("witness")
  const authoritiesCalled = watch("authoritiesCalled");
  return (
    <div

      className="w-full mx-auto p-6 bg-white shadow-md rounded-md space-y-8 text-sm"
    >
      <h2 className="text-2xl font-bold text-[#EF7320]">PROPERTY DAMAGE NOTICE</h2>



      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="col-span-2">
          <label className="block font-medium mb-1">Summary of What Happened</label>
          <textarea {...register("property_summary", { required: "Summary is required", maxLength: { value: 750, message: "Maximum 750 characters allowed" } })}
            rows={4}
            maxLength={750}
            className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
          {errors.property_summary && <p className="text-red-500 text-sm mt-1">{errors.property_summary.message}</p>}
        </div>


        <div className="col-span-2">
          <label className="block font-medium mb-1">Did you get/know driver details?</label>
          <select {...register("driver_info", { required: "Select an option" })}
            className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            <option value="">-- Select --</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors.driver_info && <p className="text-red-500 text-sm mt-1">{errors.driver_info.message}</p>}
        </div>


        {driver_info === "Yes" && (
          <>
            <div>
              <label className="block font-medium mb-1">Driver Name</label>
              <input {...register("driver_name", { required: "Name is required" })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.driver_name && <p className="text-red-500 text-sm mt-1">{errors.driver_name.message}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">Driving Street</label>
              <input {...register("driver_street", {
                required: "Driver street required"
              })
              }
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.driver_street && <p className="text-red-500 text-sm mt-1">{errors.driver_street.message}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">Driver City</label>
              <input {...register("driver_city", {
                required: "Driver city required"
              })
              }
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.driver_city && <p className="text-red-500 text-sm mt-1">{errors.driver_city.message}</p>}
            </div>
            <div>
              <label className="block font-medium mb-1">Driver State</label>
              <input {...register("driver_state", {
                required: "Driver State required"
              })
              }
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.driver_state && <p className="text-red-500 text-sm mt-1">{errors.driver_state.message}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">Driver Zip</label>
              <input {...register("driver_zip", {
                required: "Driver Zip required"
              })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.driver_zip && <p className="text-red-500 text-sm mt-1">{errors.driver_zip.message}</p>}
            </div>
          </>
        )}
        <div className="col-span-2">
          <label className="block font-medium mb-1">Did you get Insurance Information ?</label>
          <select {...register("insurance_info", { required: "Select an option" })}
            className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            <option value="">-- Select --</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors.insurance_info && <p className="text-red-500 text-sm mt-1">{errors.insurance_info.message}</p>}
        </div>


        {insurance_info === "Yes" && (
          <>
            <div>
              <label className="block font-medium mb-1">Insurance Company Name</label>
              <input {...register("insurance_company_name", { required: "Insurance Company Name is required" })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.insurance_company_name && <p className="text-red-500 text-sm mt-1">{errors.insurance_company_name.message}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">Insurance Policy </label>
              <input {...register("insurance_policy", {
                required: "Insurance Policy required"
              })
              }
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.insurance_policy && <p className="text-red-500 text-sm mt-1">{errors.insurance_policy.message}</p>}
            </div>
          </>
        )}


        <div className="col-span-2">
          <label className="block font-medium mb-1">Did you get vehicle Information ?</label>
          <select {...register("vechile_info", { required: "Select an option" })}
            className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            <option value="">-- Select --</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors.vechile_info && <p className="text-red-500 text-sm mt-1">{errors.vechile_info.message}</p>}
        </div>


        {vechile_info === "Yes" && (
          <>
            <div>
              <label className="block font-medium mb-1">State of License</label>
              <input {...register("state_of_license", { required: "State of License is required" })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.state_of_license && <p className="text-red-500 text-sm mt-1">{errors.state_of_license.message}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">License Plate Number </label>
              <input {...register("license_plate_no", {
                required: "License Plate Number required"
              })
              }
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.license_plate_no && <p className="text-red-500 text-sm mt-1">{errors.license_plate_no.message}</p>}
            </div>


          </>
        )}

        <div className="col-span-2">
          <label className="block font-medium mb-1">Witness Present?</label>
          <select {...register("witness", { required: "Select an option" })}
            className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            <option value="">-- Select --</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors.witness && <p className="text-red-500 text-sm mt-1">{errors.witness.message}</p>}
        </div>

        {/* Witness Details */}
        {witness === "Yes" && (
          <>
            <div>
              <label className="block font-medium mb-1">Witness Name</label>
              <input {...register("witness_name", { required: "Name is required" })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.witness_name && <p className="text-red-500 text-sm mt-1">{errors.witness_name.message}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">Witness Email</label>
              <input {...register("witness_email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email address"
                }
              })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.witness_email && <p className="text-red-500 text-sm mt-1">{errors.witness_email.message}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">Witness Phone</label>
              <input {...register("witness_phone", {
                required: "Phone is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Enter valid 10-digit number"
                }
              })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.witness_phone && <p className="text-red-500 text-sm mt-1">{errors.witness_phone.message}</p>}
            </div>
          </>
        )}
        {/* Authorities Called */}
        <div className="col-span-2">
          <label className="block font-medium mb-1">Is Authorities (Police, Fire, Ambulance) Called?</label>
          <select {...register("authoritiesCalled", { required: "Select an option" })}
            className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500">
            <option value="">-- Select --</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors.authoritiesCalled && <p className="text-red-500 text-sm mt-1">{errors.authoritiesCalled.message}</p>}
        </div>

        {/* Conditionally shown fields if Authorities Called = Yes */}
        {authoritiesCalled === "Yes" && (
          <>
            <div>
              <label className="block font-medium mb-1">Responding Authority Name</label>
              <input {...register("responding_authority", { required: "Enter authority name" })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.responding_authority && <p className="text-red-500 text-sm mt-1">{errors.responding_authority.message}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">Report Number</label>
              <input {...register("report_number", { required: "Enter report number" })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
              {errors.report_number && <p className="text-red-500 text-sm mt-1">{errors.report_number.message}</p>}
            </div>
          </>
        )}

      </div>


      <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4'>
        <div >
          <label className="block font-medium mb-1">Reported By</label>
          <input className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" {...register("reported_by", { required: "fill the reported by" })} value={manager} />
          {errors.reported_by && <p className="text-red-500 text-sm mt-1">{errors.reported_by.message}</p>}
        </div>

        <div>
          <label className="block font-medium mb-1">Report Date</label>

          <Controller
            control={control}
            name="reported_date"
            defaultValue={new Date()}
            rules={{ required: "Select Reported Date" }}
            render={({ field }) => (
              <DatePicker
                {...field}
                selected={field.value}
                onChange={(val) => field.onChange(val)}
                dateFormat="dd-MMM-yyyy"
                disabled
                className="w-full border border-gray-300 rounded px-4 py-2 me-22 bg-gray-100 cursor-not-allowed"
                placeholderText="Select date"
              />
            )}
          />



          {errors.reported_date && (
            <p className="text-red-500 text-sm mt-1">
              {errors.reported_date.message}
            </p>
          )}
        </div>

      </div>
      <div className="flex gap-4 mt-6">
        <button type="button" onClick={() => handleSubmit(onReview)()} className="bg-orange-600 text-white px-6 py-2 rounded-lg hover:bg-orange-700">
          Preview
        </button>
        <button type="button" onClick={goBack} className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600">
          Back
        </button>
      </div>

    </div>
  );
}
